import {
    DefaultHotKeyCommand,
    lazyShowCalendarNotificationWithButtonCallback,
} from 'owa-calendar-notification-bar';

/**
 * Shows the calendar error notification with a retry button with the given properties
 * @param {string} actionName A name used for diagnostic purposes to describe the action taken.
 * @param {string} errorString A message to display to the user in the event of a service error for this action
 * @param icon the icon to show next to the notification
 * @param actionText the text to show for the retry button
 * @param actionClickedCallback the callback to execute when the button is clicked to retry
 */
export default function showCalendarErrorNotification(
    actionName: string,
    errorString: string,
    icon: string,
    actionText?: string,
    actionClickedCallback?: () => void
) {
    lazyShowCalendarNotificationWithButtonCallback
        .import()
        .then(showNotificationWithButtonCallback => {
            showNotificationWithButtonCallback(
                actionName,
                'Surface',
                errorString,
                actionText,
                actionClickedCallback,
                icon,
                DefaultHotKeyCommand.Retry
            );
        });
}
